/**
 * JCRM Notification Message Formattes
 *
 */

import React from "react";

function CommonJCRM({ info = {}, clearMessage }){
	const { data = {}, status } = info;
	let libraryName = data.creativeLibrary?.name || data.library?.name;
	let clear;

	if(/in progress/i.test(status)){
		// If we don't include an element in this spot, the library name gets truncated in a stupid way.
		clear = <b key="clear" />;
	} else{
		clear = <i key="clear" className="ft-ic fal fa-times clear-message" title="Clear Message" onClick={clearMessage} />;
	}

	let elements = [
		clear
		, <b key="empty" />
		, <span key="footer" className="message-footer name-overflow" title={libraryName}>{libraryName || "Library"}</span>
		, <time key="time" className="message-time" dateTime={info.timestamp}>{info.prettyTime}</time>
	];

	return elements;
}

export function ImportVersions(props){
	let { info = {} } = props;
	let message = info.data?.response?.feedback || "";

	if(/in progress/gi.test(info.status)){
		message = `Import in progress...`;
	}

	if (/success/gi.test(info.status)) {
		let { changes } = info.data?.response || {};

		message = "No new versions";
		info.iconInfo = {
			title: 'Warn',
			icon: 'fas fa-info-circle',
		};

		if(changes?.creatives?.length){
			const numNewVersions = changes.creatives[0].new;
			if (numNewVersions > 0) {
				message = `${changes.creatives[0].new} version${numNewVersions > 1 ? "s" : ""} added`;
				info.iconInfo = {
					title: 'Success',
					icon: 'fas fa-check-circle is-success',
				};
			}
		}
	}

	if(/failed/gi.test(info.status)) {
		message = 'Import versions failed, please try again';
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${info.iconInfo?.icon}`} title={info.iconInfo?.title} />
		, <div key="body" className="message-body">
			<p>{message}</p>
		</div>
		, <CommonJCRM key="common" {...props} />
	];
}

export function ImportVersionsPreview(props){
	let { info = {} } = props;
	let message = info.data?.response?.feedback || "";
	let filename = info.data?.request?.filename || "versions";
	let libraryId = info.data?.creativeLibrary?.id;
	let { jobId } = info;

	// TODO: Change to full Hopi URL
	const url = `/library/${libraryId}/modal/preview-version-import/${jobId}/`;

	if(/in progress/gi.test(info.status)){
		message = (<p>Import in progress...</p>);
	}

	if (/success/gi.test(info.status)) {
		const updatedCreatives = (info.data?.response?.changes?.creatives || []).filter((creative) => {
			const creativeChanges = creative.updated + creative.new;
			return creativeChanges > 0;
		});

		if(updatedCreatives.length){
			message = (
				<>
					<p>
						<span className="name-overflow">{`Import of "${filename}"`}</span>
						is ready to preview
					</p>
					<p><a href={url} target="_BLANK">Preview Import</a></p>
				</>
			);

			info.iconInfo = {
				title: 'Success',
				icon: 'fas fa-check-circle is-success',
			};
		} else {
			message = <p>No new versions</p>;
			info.iconInfo = {
				title: 'Warn',
				icon: 'fas fa-info-circle',
			};
		}
	}

	if(/failed/gi.test(info.status)) {
		message = (<p>Import versions failed, please try again</p>);
		info.iconInfo = {
			title: 'Failed',
			icon: 'fas fa-times-circle is-error',
		};
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${info.iconInfo?.icon}`} title={info.iconInfo?.title} />
		, <div key="body" className="message-body">{message}</div>
		, <CommonJCRM key="common" {...props} />
	];
}

export function AddVersionsToLibrary(props) {
	const { info = {} } = props;
	const { status, data = {}, error, iconInfo } = info;
	const { message = "" } = data;

	//For in progress, we want to show the message coming from jobs
	let feedback = (<p>{message}</p>);

	if (/success/gi.test(status)) {
		//For success we want to twick a message coming from API
		feedback = (<p>{message.replace(/Generating/, "Successfully added")}</p>);
	}

	if (/failed/gi.test(status)) {
		feedback = (<p>{error.description}</p>);
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${iconInfo?.icon}`} title={info.iconInfo?.title} />
		, <div key="body" className="message-body">{feedback}</div>
		, <CommonJCRM key="common" {...props} />
	];
}

export function ExportComplete(props){
	let { info = {} } = props;
	let message = ""
		, $download = null
		;

	if(/export versions/gi.test(info.task)){
		message = `Creative versions export is ready to download`;
	}

	if(/in progress/gi.test(info.status)){
		message = `Export in progress...`;
	} else if (/failed/gi.test(info.status)) {
		message = `There was a problem building the export, please try again`;
	} else {
		$download = <a href={info.downloadLink} download={info.data?.request?.filename}>Download Export</a>;
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${info.iconInfo?.icon}`} title={info.iconInfo?.title} />
		, <div key="body" className="message-body">
			<p>{message}</p>
			{$download}
		</div>
		, <CommonJCRM key="common" {...props} />
	];
}

export function EncodeVastVideo(props){
	let { info = {} } = props;
	let { name = "" } = info.data?.creative || {};
	let message = "";

	if(/in progress/gi.test(info.status)){
		message = " in progress.";
	} else if(/failed/gi.test(info.status)){
		message = " failed.";
	} else {
		message = " successfully completed.";
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${info.iconInfo?.icon}`} title={info.iconInfo?.title} />
		, <div key="body" className="message-body">
			<p>
				Video processing for VAST creative <span className="text-overflow" title={name}>{`'${name}'`}</span>{message}
			</p>
		</div>
		, <CommonJCRM key="common" {...props} />
	];
}

export function EncodeVideo(props){
	let { info = {} } = props;
	let { name = "" } = info.data?.request || {};
	let message = "";

	if(/in progress/gi.test(info.status)){
		message = " is in progress.";
	} else if(/failed/gi.test(info.status)){
		message = " failed.";
	} else {
		message = " successfully completed.";
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${info.iconInfo?.icon}`} title={info.iconInfo?.title} />
		, <div key="body" className="message-body">
			<p>
				Video transcoding for <span className="text-overflow" title={name}>{`'${name}'`}</span>{message}
			</p>
		</div>
		, <CommonJCRM key="common" {...props} />
	];
}

export function UploadVideo(props){
	let { info = {} } = props;
	let message = "";

	if(/in progress/gi.test(info.status)){
		message = "Uploading Video Asset";
	} else if(/success/gi.test(info.status)){
		let name = info.data?.asset?.name;
		message = <><span className="text-overflow" title={name}>{name}</span> successfully uploaded.</>;
	} else if (/failed/gi.test(info.status)) {
		message =  info.error?.description || "Video Upload failed";
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${info.iconInfo?.icon}`} title={info.iconInfo?.title} />
		, <div key="body" className="message-body">
			<p>{message}</p>
		</div>
		, <CommonJCRM key="common" {...props} />
	];
}

export function UploadAudio(props) {
	let { info = {} } = props;
	let message = "";

	if(/in progress/gi.test(info.status)){
		message = "Uploading Audio Asset";
	} else if(/success/gi.test(info.status)){
		let name = info.data?.asset?.name;
		message = <><span className="text-overflow" title={name}>{name}</span> successfully uploaded.</>;
	} else if (/failed/gi.test(info.status)) {
		message =  info.error?.description || "Audio Upload failed";
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${info.iconInfo?.icon}`} title={info.iconInfo?.title} />
		, <div key="body" className="message-body">
			<p>{message}</p>
		</div>
		, <CommonJCRM key="common" {...props} />
	];
}

export function EncodeAudio(props){
	let { info = {} } = props;
	let { name = "" } = info.data?.creative || {};
	let message = "";

	if(/in progress/gi.test(info.status)){
		message = " in progress.";
	} else if(/failed/gi.test(info.status)){
		message = " failed.";
	} else {
		message = " successfully completed.";
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${info.iconInfo?.icon}`} title={info.iconInfo?.title} />
		, <div key="body" className="message-body">
			<p>
				Audio processing for VAST creative <span className="text-overflow" title={name}>{`'${name}'`}</span>{message}
			</p>
		</div>
		, <CommonJCRM key="common" {...props} />
	];
}

export function BaseJCRM(props){
	let { info = {} } = props;

	let message = "Action in Progress";

	if(/in progress/gi.test(info.status)){
		message = "In progress...";
	} else if(/complete/gi.test(info.status)){
		message = "Task Complete";
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${info.iconInfo?.icon}`} title={info.iconInfo?.title} />
		, <div key="body" className="message-body">
			<p>{message}</p>
		</div>
		, <CommonJCRM key="common" {...props} />
	];
}

export function ImportSocial(props){
	let { info = {} } = props
		,  message = "";

	if(/in progress/gi.test(info.status)){
		message = info.data?.message || `Importing Social Creatives`;
	} else if(/success/gi.test(info.status)){
		let name = info.data?.request?.filename
			, importInfo = info.data?.response?.feedback
			;

		message = (
			<div>
				<span>{importInfo}</span>
				<span className="text-overflow" title={name}>{name}</span> successfully uploaded.
			</div>
		);
	} else if(/failed/gi.test(info.status)){
		message = `Error importing social creatives sheet: ${info.data?.request?.filename}`;
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${info.iconInfo?.icon}`} title={info.iconInfo?.title} />
		, <div key="body" className="message-body">
			<p>{message}</p>
		</div>
		, <CommonJCRM key="common" {...props} />
	];
}

export function ImportYoutubeUrlCreatives(props){
	let { info = {} } = props
		,  message = "";
	let name = info.data?.request?.filename;
	if(/in progress/gi.test(info.status)){
		message = info.data?.message || `Importing YouTube URL Creatives`;
	} else if(/success/gi.test(info.status)){
		message = (
			<>
				<span className="text-overflow" title={name}>{name}</span> successfully uploaded.
			</>
		);
	} else if(/failed/gi.test(info.status)){
		const suffix = name ? `: ${name}` : "";
		message = `Error importing YouTube URL creatives file${suffix}`;
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${info.iconInfo?.icon}`} title={info.iconInfo?.title} />
		, <div key="body" className="message-body">
			<p>{message}</p>
		</div>
		, <CommonJCRM key="common" {...props} />
	];
}

export function ImportCreativeLabels(props){
	let { info = {} } = props
		,  message = "";

	if(/in progress/gi.test(info.status)){
		message = "Importing Creative Labels";
	} else if(/success/gi.test(info.status)){
		let name = info.data?.request?.filename
			, importInfo = info.data?.response?.feedback
			;

		message = (
			<div>
				<span>{importInfo}</span>
				<span className="text-overflow" title={name}>{name}</span> successfully uploaded.
			</div>
		);
	} else if(/failed/gi.test(info.status)){
		message = `Error importing creative labels: ${info.data?.request?.filename}`;
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${info.iconInfo?.icon}`} title={info.iconInfo?.title} />
		, <div key="body" className="message-body">
			<p>{message}</p>
		</div>
		, <CommonJCRM key="common" {...props} />
	];
}


function ImposiumVersionRender(props){
	const { info = {} } = props;
	const { data = {} } = info;
	let { message = "" } = data;

	if (/failed/i.test(info.status)) {
		message = info.error?.description || "Imposium version render failed";
	} else if (/in progress/i.test(info.status)) {
		message = message || "Imposium version render in progress...";
	} else if (/success/i.test(info.status)) {
		message = message || "Imposium version render completed";
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${info.iconInfo?.icon}`} title={info.iconInfo?.title} />
		, <div key="body" className="message-body">
			<p>{message}</p>
		</div>
		, <CommonJCRM key="common" {...props} />
	];
}

export function DataNameAsMessage(props){
	const { info = {} } = props;
	const { data = {} } = info;
	let { name = "" } = data;
	return [
		<i key="status-icon" className={`ft-ic status-icon ${info.iconInfo?.icon}`} title={info.iconInfo?.title} />
		, <div key="body" className="message-body">
			<p>{name}</p>
		</div>
		, <CommonJCRM key="common" {...props} />
	];
}


export function CreativeTransition(props){
	const { info = {} } = props;
	const { data = {} } = info;
	let { message = "", approval = "" } = data;
	const isImposiumVersionRender = /imposium version render/i.test(data?.jobType);

	//imposium version rendering is considered a type of creative transition, because rendering changes the status field
	if (isImposiumVersionRender) {
		return ImposiumVersionRender(props);
	}

	if (!message) {
		if (/in progress/gi.test(info.status)) {
			message = "Creative transition in progress";
		} else if (/success/gi.test(info.status)) {
			message = "Creative transition succeeded";
		} else if (/failed/gi.test(info.status)) {
			message = "Creative transition failed";
		}
	}

	/*
		Currently, when a creative transitions to TRANSCODING or TRANSCODING_ERROR the messages returned are
		'Transcoding' and 'Error' respectively. We want to change these notifications to be 'Processing' and
		'Processing Error' instead.

		e.g.

		VAST.mp4 moved to Transcoding -> VAST.mp4 moved to Processing
		VAST.mp4 moved to Error -> VAST.mp4 moved to Processing Error.
	*/
	if(/transcoding_error/i.test(approval)){
		message = message.replace(/error$/i, "Processing Error");
	}else if(/transcoding/i.test(approval)) {
		message = message.replace(/transcoding$/i, "Processing");
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${info.iconInfo?.icon}`} title={info.iconInfo?.title} />
		, <div key="body" className="message-body">
			<p>{message}</p>
		</div>
		, <CommonJCRM key="common" {...props} />
	];
}

export function ImposiumProjectDuplication(props){
	let { info = {} } = props;
	const { status, data = {} } = info;
	let newProjectName = data?.imposiumProject?.name || "";
	let message = "";

	if (/in progress/i.test(status)) {
		message = "Duplicating Imposium project...";
	} else if (/success/i.test(status)) {
		if (newProjectName) {
			message = `Imposium project '${newProjectName}' created`;
		} else {
			message = "Imposium project successfully created";
		}
	} else if (/failed/i.test(status)) {
		message = info.error?.description || "Imposium project duplication failed";
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${info.iconInfo?.icon}`} title={info.iconInfo?.title} />
		, <div key="body" className="message-body">
			<p>{message}</p>
		</div>
		, <CommonJCRM key="common" {...props} />
	];
}
